import { LEVEL_WIDTH, TileData, TileType } from "./types";
import { tileKey, type EnemySpawn, type LevelData } from "./level";

// World 3-4: Castle — long pit section, moving platforms, few enemies
export function buildLevel3_4(): LevelData {
  const tiles = new Map<string, TileData>();
  const groundTop = -1;
  const groundDepth = 2;

  const setTile = (x: number, y: number, type: TileType, payload?: TileData["payload"], flower?: boolean): void => {
    tiles.set(tileKey(x, y), { type, payload, broken: false, bump: 0, flower: flower || undefined });
  };

  // castle: ground 0..16, pit 17..52 (platforms), ground 53..108, pit 109..154 (platforms), ground 155..200
  for (let x = 0; x <= 16; x++) {
    for (let dy = 0; dy < groundDepth; dy++) setTile(x, groundTop - dy, TileType.Ground);
  }

  // platforms over pit 1
  for (let x = 17; x <= 52; x += 5) {
    for (let dy = 0; dy < groundDepth; dy++) setTile(x + 2, groundTop - dy, TileType.Ground);
  }

  for (let x = 53; x <= 108; x++) {
    for (let dy = 0; dy < groundDepth; dy++) setTile(x, groundTop - dy, TileType.Ground);
  }

  // platforms over pit 2
  for (let x = 109; x <= 154; x += 5) {
    for (let dy = 0; dy < groundDepth; dy++) setTile(x + 2, groundTop - dy, TileType.Ground);
  }

  for (let x = 155; x <= 200; x++) {
    for (let dy = 0; dy < groundDepth; dy++) setTile(x, groundTop - dy, TileType.Ground);
  }

  // blocks along the way
  setTile(8, 4, TileType.Question, { kind: "mushroom" });
  setTile(60, 4, TileType.Brick);
  setTile(61, 4, TileType.Brick);
  setTile(62, 4, TileType.Question, { kind: "coin" });
  setTile(63, 4, TileType.Brick);

  setTile(80, 4, TileType.Question, { kind: "coin" });
  setTile(90, 4, TileType.Brick);
  setTile(91, 4, TileType.Brick);
  setTile(92, 4, TileType.Brick);

  setTile(115, 4, TileType.Question, { kind: "coin" });
  setTile(130, 4, TileType.Brick);
  setTile(131, 4, TileType.Brick);
  setTile(132, 4, TileType.Brick);

  setTile(162, 4, TileType.Question, { kind: "mushroom" });
  setTile(170, 4, TileType.Brick);
  setTile(171, 4, TileType.Brick);

  const flagX = 198;
  for (let y = groundTop + 1; y <= 21; y++) setTile(flagX, y, TileType.Pole);
  setTile(flagX, 22, TileType.Block);

  const castleX = 202;

  const enemies: EnemySpawn[] = [
    { kind: "goomba", x: 23 },
    { kind: "goomba", x: 33 },
    { kind: "goomba", x: 43 },
    { kind: "koopa", x: 60 },
    { kind: "goomba", x: 70 },
    { kind: "goomba", x: 80 },
    { kind: "goomba", x: 90 },
    { kind: "koopa", x: 100 },
    { kind: "goomba", x: 115 },
    { kind: "goomba", x: 125 },
    { kind: "koopa", x: 135 },
    { kind: "goomba", x: 145 },
    { kind: "goomba", x: 160 },
    { kind: "goomba", x: 170 },
    { kind: "goomba", x: 180 }
  ];

  return { tiles, enemies, enterablePipes: [], flagX, castleX, width: LEVEL_WIDTH, groundY: 0 };
}
